/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_4_AnswerInputs */

const en_svc_rag_faq_4_answer = /** @type {(inputs: Svc_Rag_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. One indexed source can power an internal assistant and a public chatbot, with different permissions and different rules about what each may answer.`)
};

const lv_svc_rag_faq_4_answer = /** @type {(inputs: Svc_Rag_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Viens indeksēts avots var darbināt gan iekšējo asistentu, gan publisku čatbotu, ar atšķirīgām piekļuves tiesībām un noteikumiem par to, ko katrs drīkst atbildēt.`)
};

/**
* | output |
* | --- |
* | "Yes. One indexed source can power an internal assistant and a public chatbot, with different permissions and different rules about what each may answer." |
*
* @param {Svc_Rag_Faq_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_4_answer = /** @type {((inputs?: Svc_Rag_Faq_4_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_4_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_4_answer(inputs)
	return en_svc_rag_faq_4_answer(inputs)
});